// Components==============
import { useMediaQ } from 'hooks/useMediaQ';
import { useStorage } from 'hooks/useStorage';
import React, { createContext, useMemo } from 'react';
// =========================

type GlobalFilterMenuContextType = {
  filterMenuIsOpen: boolean;
  setFilterMenuIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const GlobalFilterMenuContext = createContext(
  {} as GlobalFilterMenuContextType
);

export default function GlobalFilterMenu({
  children,
}: {
  children: React.ReactNode;
}) {
  const isDesktop = useMediaQ('min', 1024);

  const [filterMenuIsOpen, setFilterMenuIsOpen] = useStorage(
    'filterMenuIsOpen',
    isDesktop
  );

  const value = useMemo(
    () => ({
      filterMenuIsOpen,
      setFilterMenuIsOpen,
    }),
    [filterMenuIsOpen]
  );

  return (
    <GlobalFilterMenuContext.Provider value={value}>
      {children}
    </GlobalFilterMenuContext.Provider>
  );
}
